var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_873_81148)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.218 4.026C16.2164 1.44041 20.0407 0.0124155 24 0C32.07 0 38.769 6 39.498 13.737C44.274 14.412 48 18.411 48 23.319C48 28.707 43.506 33 38.061 33H30C29.6022 33 29.2206 32.842 28.9393 32.5607C28.658 32.2794 28.5 31.8978 28.5 31.5C28.5 31.1022 28.658 30.7206 28.9393 30.4393C29.2206 30.158 29.6022 30 30 30H38.064C41.937 30 45 26.964 45 23.319C45 19.671 41.94 16.635 38.061 16.635H36.561V15.135C36.564 8.475 30.984 3 24 3C20.7596 3.01294 17.6305 4.1833 15.177 6.3C12.906 8.256 11.718 10.614 11.718 12.465V13.809L10.383 13.956C6.192 14.415 3 17.856 3 21.954C3 26.355 6.69 30 11.343 30H18C18.3978 30 18.7794 30.158 19.0607 30.4393C19.342 30.7206 19.5 31.1022 19.5 31.5C19.5 31.8978 19.342 32.2794 19.0607 32.5607C18.7794 32.842 18.3978 33 18 33H11.343C5.124 33 0 28.098 0 21.954C0 16.665 3.798 12.285 8.826 11.175C9.255 8.586 10.92 6.006 13.218 4.026Z",
    fill: "#1C2026"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.9379 12.4379C23.0773 12.2982 23.2428 12.1874 23.425 12.1117C23.6073 12.0361 23.8026 11.9972 23.9999 11.9972C24.1972 11.9972 24.3926 12.0361 24.5748 12.1117C24.7571 12.1874 24.9226 12.2982 25.0619 12.4379L34.0619 21.4379C34.3436 21.7195 34.5018 22.1015 34.5018 22.4999C34.5018 22.8982 34.3436 23.2802 34.0619 23.5619C33.7803 23.8435 33.3983 24.0018 32.9999 24.0018C32.6016 24.0018 32.2196 23.8435 31.9379 23.5619L25.4999 17.1209V43.4999C25.4999 43.8977 25.3419 44.2792 25.0606 44.5605C24.7793 44.8418 24.3978 44.9999 23.9999 44.9999C23.6021 44.9999 23.2206 44.8418 22.9393 44.5605C22.658 44.2792 22.4999 43.8977 22.4999 43.4999V17.1209L16.0619 23.5619C15.7803 23.8435 15.3983 24.0018 14.9999 24.0018C14.6016 24.0018 14.2196 23.8435 13.9379 23.5619C13.6563 23.2802 13.498 22.8982 13.498 22.4999C13.498 22.1015 13.6563 21.7195 13.9379 21.4379L22.9379 12.4379Z",
    fill: "#1C2026"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_873_81148"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/upload-icon.0d70059d7388b6c7cc6a65f2fdd0fece.svg";
export { ForwardRef as ReactComponent };